import { render } from "./PointReport.vue?vue&type=template&id=02a0570c&scoped=true"
import script from "./PointReport.vue?vue&type=script&lang=js"
export * from "./PointReport.vue?vue&type=script&lang=js"

import "./PointReport.vue?vue&type=style&index=0&id=02a0570c&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a0570c"]])

export default __exports__